module.exports = __webpack_public_path__ + "static/media/181CO209.02a5c905.jpg";